import en from './en.json'
import es from './es.json'

const translations = { en, es }

export default translations
